module.exports = __webpack_public_path__ + "static/Ochou.153497c4.jpeg";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/assets/team/Ochou.jpeg
// module id = 939
// module chunks = 3